/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import cx from 'classnames';
import React, { memo, useState } from 'react';

import { ButtonBase, MenuItem } from '@mui/material';

import { ArrowRoundedIcon } from '../../../components/svg-icons/ArrowRoundedIcon';
import { StyledMenu, useUnitPickerStyles } from './UnitPicker.styles';
import { CapacityUnits } from './UnitPicker.types';

export type UnitPickerProps = {
  unit: CapacityUnits;
  onUnitChange: (val: CapacityUnits) => void;
  unitOptions: CapacityUnits[];
};

export const UnitPicker = memo<UnitPickerProps>(props => {
  const { unit, onUnitChange, unitOptions } = props;

  const classes = useUnitPickerStyles();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const isDisabled = unitOptions.length < 2;

  const handleUnitClick = (val: CapacityUnits) => {
    onUnitChange(val);
    setAnchorEl(null);
  };

  return (
    <>
      <ButtonBase
        className={classes.unitLabel}
        aria-controls="customized-menu"
        aria-haspopup="true"
        onClick={e => setAnchorEl(e.currentTarget)}
        disabled={isDisabled}
      >
        {unit}
        {!isDisabled && (
          <ArrowRoundedIcon
            className={cx({
              [classes.iconOpen]: Boolean(anchorEl),
            })}
          />
        )}
      </ButtonBase>

      {!isDisabled && (
        <StyledMenu anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
          {unitOptions.map(val => (
            <MenuItem key={val} onClick={() => handleUnitClick(val)}>
              {val}
            </MenuItem>
          ))}
        </StyledMenu>
      )}
    </>
  );
});
